var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Polyglot from 'node-polyglot';
import globalTranslations from '../../translations.yml';
const polyglot = new Polyglot({ interpolation: { prefix: '{', suffix: '}' } });
polyglot.extend(globalTranslations);
/**
 * Register a translation set.
 *
 * @param {object} translations
 */
export const addTranslations = (translations) => __awaiter(void 0, void 0, void 0, function* () {
    polyglot.extend(translations);
});
/**
 * Check if a translation exists for a certain key.
 *
 * @param {string} key
 *
 * @returns bool
 */
export const hasTranslation = (key) => {
    return polyglot.has(key);
};
export default (key, variables) => polyglot.t(key, variables);
